import React from "react";

const SearchBar = (props) => {
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      props.getSearchKeyword(e.target.value);
    }
  };
const textCss = `.search-wrapper {
  height: 500px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 ${props.initialImage ? "5px" : "0"} #dbdada;
}
.search-wrapper::after {
  content: "";
  background: url("${props.initialImage}");
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;   
  background-size: 100% 500px
}`
  return (
    <div
      className="search-wrapper"
      // style={{
      //   backgroundImage: props.initialImage ? `url(${props.initialImage})` : "",
      //   backgroundSize: props.initialImage ? "100% 500px" : "", 
      //   backgroundRepeat: "no-repeat",  
      //   backgroundColor: "transparent"     
      // }}
    >
      {/* This style tag is inserted here to decrease the opicity 
      of the dynamically inserted  BG Image with pesudo selectors*/}
      <style>
        {textCss}
      </style>
      <input
        type="text"
        onKeyDown={handleSearch}
        className="search-input"
        placeholder="Search any word.."
      />
    </div>
  );
};

export default SearchBar;
